import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import useWorkspaceNavigate from "common/hooks/useWorkspaceNavigate";

import useLeadListMutations from "../../datahooks/useLeadListMutations";

import type { LeadList } from "../../types";

interface LeadListDeleteProps {
  leadList: LeadList;
  onBack: () => void;
  onClose: () => void;
}

export default function LeadListDelete({
  leadList,
  onBack,
  onClose,
}: LeadListDeleteProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { deleteList, isDeletingList } = useLeadListMutations();
  const { relativeNavigate } = useWorkspaceNavigate();

  function onDelete() {
    deleteList(leadList.id).then(() => {
      onClose();
      relativeNavigate("lists");
    });
  }

  const Header = isDesktop ? DialogHeader : DrawerHeader;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;

  return (
    <>
      <Header
        title="Delete list?"
        subtitle="Are you sure you want to delete this list?"
      />

      <Footer className="justify-end">
        <Button
          variant="secondary-black"
          disabled={isDeletingList}
          onClick={onBack}
        >
          Cancel
        </Button>

        <Button
          variant="outline-danger"
          onClick={onDelete}
          isLoading={isDeletingList}
        >
          Delete
        </Button>
      </Footer>
    </>
  );
}
